"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var user_1 = __importDefault(require("Utils/redux/reducers/user"));
var typings_1 = require("Utils/redux/reducers/typings");
var router_1 = __importDefault(require("Utils/redux/reducers/router"));
var rootReducer = redux_1.combineReducers({
    user: user_1.default,
    loginForm: typings_1.loginForm,
    generalForm: typings_1.generalForm,
    router: router_1.default
});
exports.default = rootReducer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvcmVkdXgvcmVkdWNlcnMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSwrQkFBd0M7QUFDeEMsbUVBQTZDO0FBQzdDLHdEQUFzRTtBQUN0RSx1RUFBaUQ7QUFFakQsSUFBTSxXQUFXLEdBQUcsdUJBQWUsQ0FBQztJQUNsQyxJQUFJLGdCQUFBO0lBQ0osU0FBUyxxQkFBQTtJQUNULFdBQVcsdUJBQUE7SUFDWCxNQUFNLGtCQUFBO0NBQ1AsQ0FBQyxDQUFDO0FBRUgsa0JBQWUsV0FBVyxDQUFDIn0=